import { render, staticRenderFns } from "./birthdayListItem.vue?vue&type=template&id=e0e8440c"
import script from "./birthdayListItem.vue?vue&type=script&lang=ts"
export * from "./birthdayListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports